import { render, staticRenderFns } from "./View.vue?vue&type=template&id=5e1d8b78"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e1d8b78')) {
      api.createRecord('5e1d8b78', component.options)
    } else {
      api.reload('5e1d8b78', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=5e1d8b78", function () {
      api.rerender('5e1d8b78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/payments/View.vue"
export default component.exports